/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/class/KavenAbstractSocket.ts
 * @create:      2019-11-16 06:51:28.978
 * @modify:      2025-06-30 17:20:26.629
 * @version:     6.0.0
 * @times:       17
 * @lines:       83
 * @copyright:   Copyright © 2019-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { IKavenLiteEvent } from "../interface/IKavenLiteEvent";
import { KavenLiteEvent } from "./KavenLiteEvent";

export abstract class KavenAbstractSocket<TSocket, TMessage> {
    public get Connected(): IKavenLiteEvent<TSocket, this> {
        return this.onConnected.expose();
    }

    public get Disconnected(): IKavenLiteEvent<TSocket, this> {
        return this.onDisconnected.expose();
    }

    public get DataReceived(): IKavenLiteEvent<TMessage, this> {
        return this.onDataReceived.expose();
    }

    public get Socket(): TSocket {
        return this.socket;
    }

    private socket: TSocket;

    // #region Events
    private readonly onConnected = new KavenLiteEvent<TSocket, this>();
    private readonly onDisconnected = new KavenLiteEvent<TSocket, this>();
    private readonly onDataReceived = new KavenLiteEvent<TMessage, this>();
    // #endregion

    public constructor(socket: TSocket) {
        this.socket = socket;
    }

    public abstract Send(msg: TMessage): void;

    protected OnConnected() {
        return this.onConnected.trigger(this.socket, this);
    }

    protected OnDisconnected() {
        return this.onDisconnected.trigger(this.socket, this);
    }

    protected OnDataReceived(data: TMessage) {
        return this.onDataReceived.trigger(data, this);
    }

    protected Reconnect(socket: TSocket) {
        this.socket = socket;
    }
}
